// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ap-b";
export var colorBlue = "_ap-8";
export var colorDot = "_ap-0";
export var colorDotLarge = "_ap-2";
export var colorDotSmall = "_ap-1";
export var colorGreen = "_ap-7";
export var colorGrey = "_ap-3";
export var colorOrange = "_ap-5";
export var colorPink = "_ap-a";
export var colorPurple = "_ap-9";
export var colorRed = "_ap-4";
export var colorYellow = "_ap-6";